import React from 'react';
import { CarouselStyles } from './style';
import styled from '@emotion/styled';
/**
 * React multi carousel library with MIT License
 * Reference link: https://www.npmjs.com/package/react-multi-carousel
 */
import { default as MultiCarousel } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { responsive } from './carouselConfig';

const Styled = styled(MultiCarousel)`
  ${CarouselStyles}
`;

export const Carousel = ({ children }) => {
  return (
    <Styled responsive={responsive} swipeable={false} draggable={false} ssr={true} keyBoardControl={false}>
      {children}
    </Styled>
  );
};
